import { authUri, marketingUri } from './constants'

const loginUri = `${marketingUri}/login`
export function redirectToLogin(redirect?: string) {
  if (
    !redirect &&
    window.location.pathname.length <= 1 &&
    window.location.search.length <= 0
  ) {
    window.location.href = loginUri
    return
  }
  window.location.href = `${loginUri}?redirect=${encodeURIComponent(redirect ?? window.location.toString())}`
}

export const redirectToLogout = () => {
  window.location.href = `${authUri}/signout`
}
